<svg
    class="animate-spin"
    [class]="color + ' ' + sizeClass"
    viewBox="0 0 50 50"
  >
    <!-- Cercle de fond -->
    <circle
      class="opacity-25"
      cx="25"
      cy="25"
      r="20"
      stroke="currentColor"
      stroke-width="5"
      fill="none"
    />
    <!-- Arc visible -->
    <circle
      class="opacity-75"
      cx="25"
      cy="25"
      r="20"
      stroke="currentColor"
      stroke-width="5"
      stroke-linecap="round"
      [attr.stroke-dasharray]="dashArray"
      stroke-dashoffset="0"
      fill="none"
    />
  </svg>


